module.exports = __webpack_public_path__ + "img/icon-start-02.svg";